import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { selectIsValidCat } from '@store/order/selectors';
import { setShowInvalids } from '@store/order/slice';
import { Button } from 'react-aria-components';



interface FooterProps {
	scrollToTop: () => void,
	goToSummary: () => void,
}


const Footer = (props: FooterProps) => {
	const { scrollToTop, goToSummary } = props;
	const { t } = useTranslation('forms');
	
	const isValid = useSelector(selectIsValidCat);
	const dispatch = useDispatch();
	const showInvalids = (show: boolean) => dispatch(setShowInvalids(show));


	const handleGoToSummary = useCallback(() => {
		if (!isValid) {
			showInvalids(true);
			setTimeout(() => scrollToTop(), 5);
			return;
		}
		goToSummary();
	},[ isValid ]);


	return (
		<div className='footer-section'>

			<Button className='app-form-button disable-selection' autoFocus={false} onPress={handleGoToSummary}>
				{t('summary.summaryLabel')}
			</Button>
			
		</div>
	);
};

export default Footer;